import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import SequencerEndWrapNodeView from "views/audioEditor/sequencerNodeView/SequencerEndWrapNodeView";
import sequencerEndMuteWrapNodeTemplate from 'text!../../../../templates/audioEditor/sequencerNodeView/SequencerEndMuteWrapNodeTemplate.html';
import ti18n from 'i18n!nls/Sequenceri18n';
import RSVP from 'rsvp';


const SequencerEndMuteWrapNodeView = SequencerEndWrapNodeView.extend({



    constructor : function(attributes, options) {
        SequencerEndWrapNodeView.apply(this, [attributes, options]);
        this.compiledTemlate =  _.template(sequencerEndMuteWrapNodeTemplate);
    },

    events : _.extend({
        "click": "onNodeClick",
        "mouseenter": "onMouseEnter",
        "mouseleave": "onMouseLeave",
        "taphold": "onTapHold",
    }, SequencerEndWrapNodeView.prototype.events),

    onNodeClick : function(){
        this.trigger("endWrapNodeClick", this);
    },

    onTapHold : function(e){
        //this.trigger("tapholdOnWrapNode",e)
    },

    onMouseEnter: function(){
        this.model.setAllNodesHoverHighlighted(true);
    },

    onMouseLeave: function(){
        this.model.setAllNodesHoverHighlighted(false);
    },


    render : function() {

        this.$el.html(this.compiledTemlate({"model": this.model}));
        this.setElement(this.$el.find("span").first());
        this.afterRendering();
        return this;
    }

});
export default SequencerEndMuteWrapNodeView;
